import { Mail, LifeBuoy, Handshake, ShoppingBag } from "lucide-react";
import { SUPPORT_EMAIL } from "@/components/SupportEmail";

const TOPICS = [
  { icon: LifeBuoy, title: "Game help", text: "Stuck on a region, lost progress or found a bug? Tell us your wolf's name and what happened." },
  { icon: ShoppingBag, title: "Orders & NFTs", text: "Questions about a purchase, credits, a delivery or a 1/1 claim. Include the email you play with." },
  { icon: Handshake, title: "Collabs & partners", text: "Projects, creators and communities who want to team up with the pack." },
];

export default function Contact() {
  return (
    <main data-testid="contact-page" className="max-w-5xl mx-auto px-4 sm:px-6 py-16">
      <p className="text-xs uppercase tracking-[0.3em] font-mono-game text-amber-400/80 mb-3 rise">Support & collabs</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-amber-100 mb-5 rise">Talk to the pack</h1>
      <p className="text-slate-300 max-w-xl mb-8 rise">One inbox for help, orders and collabs. Drop us a line and the pack will get back to you.</p>
      <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="contact-email-btn" className="ember-btn inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm mb-14 rise">
        <Mail className="w-4 h-4" />{SUPPORT_EMAIL}
      </a>
      <div className="grid md:grid-cols-3 gap-5">
        {TOPICS.map(({ icon: Icon, title, text }, i) => (
          <div key={title} data-testid={`contact-topic-${i}`} className="glass rounded-2xl p-6 rise" style={{ animationDelay: `${0.1 * (i + 1)}s` }}>
            <Icon className="w-6 h-6 text-amber-300 mb-4" />
            <p className="font-display text-xl text-white mb-2">{title}</p>
            <p className="text-sm text-slate-400">{text}</p>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-500 mt-10">We'll never ask for your password, card details or wallet recovery words.</p>
    </main>
  );
}
